export const CHECK_EXPORTABILITY = 'CHECK_EXPORTABILITY';
export const CHECK_EXPORTABILITY_SUCCESS = 'CHECK_EXPORTABILITY_SUCCESS';
export const CHECK_EXPORTABILITY_FAIL = 'CHECK_EXPORTABILITY_FAIL';
export const CHECK_EXPORTABILITY_FETCHING = 'CHECK_EXPORTABILITY_FETCHING';

export const DELETE_DAILY_SUMMARY = 'DELETE_DAILY_SUMMARY';
export const DELETE_DAILY_SUMMARY_SUCCESS = 'DELETE_DAILY_SUMMARY_SUCCESS';
export const DELETE_DAILY_SUMMARY_FAIL = 'DELETE_DAILY_SUMMARY_FAIL';
export const CLEAR_DELETE_DAILY_SUMMARY = 'CLEAR_DELETE_DAILY_SUMMARY';

export const FETCH_CLIMB_DIFFICULTIES = 'FETCH_CLIMB_DIFFICULTIES';
export const FETCH_CLIMB_DIFFICULTIES_SUCCESS = 'FETCH_CLIMB_DIFFICULTIES_SUCCESS';
